// import { format, fromZonedTime, toZonedTime } from 'date-fns-tz';
import { endOfDay, format, isMatch, isValid, parse, parseISO, startOfDay, startOfYesterday, subYears } from 'date-fns';

export const getEndOfToday = (): Date => endOfDay(new Date());

export const subtractYearsFromToday = (yearAmount: number): Date => subYears(startOfDay(new Date()), yearAmount);
export const subtractYearsFromYesterday = (yearAmount: number): Date => subYears(startOfYesterday(), yearAmount);

export const getDate100YearsAgo = (): Date => subtractYearsFromToday(100);
export const get18YearsAgo = (): Date => subtractYearsFromYesterday(18);

// export const parseDateZoneToLocalDate = (input: string, opts: { zone: string; format: string }): Date => {
//   let utcDate: Date;
//
//   // ISO string, like '2025-05-19T16:00:00.000Z'
//   if (input.includes('T')) {
//     utcDate = parseISO(input);
//   } else {
//     // Date string, like '2025-05-19', '19-05-2025', etc
//     const naiveDate = parse(input, opts.format, new Date());
//     utcDate = fromZonedTime(naiveDate, opts.zone);
//   }
//
//   return toZonedTime(utcDate, opts.zone);
// };

// export const parseLocalDateToISOZone = (date: Date, zone: string): string => {
//   const localDateStr = format(date, 'yyyy-MM-dd');
//   return fromZonedTime(`${localDateStr}T00:00:00`, zone).toISOString();
// };

/**
 * @example Local Timezone: UTC-8
 * // => '2025-06-02T08:00:00.000Z'
 * parseDateToStartOfLocalDate('2025-06-02', { format: 'yyyy-MM-dd' }).toISOString()
 *
 * // => '2025-06-02T08:00:00.000Z'
 * parseDateToStartOfLocalDate('2025-06-02T08:00:00.000Z', { format: 'yyyy-MM-dd' }).toISOString()
 */
export const parseDateToStartOfLocalDate = (input: string, opts: { format: string }): Date => {
  // If the input is already in ISO format, we can directly parse it
  if (input.includes('T')) {
    return startOfDay(parseISO(input));
  }

  return startOfDay(parse(input, opts.format, new Date()));
};

export const parseAndFormatToStartOfLocalDate = (
  value: unknown,
  opts: { format: string }
): { format: string; iso: string } | null => {
  if (typeof value !== 'string' && !(value instanceof Date)) {
    return null;
  }

  const date = parseDateToStartOfLocalDate(value instanceof Date ? value.toISOString() : value, {
    format: opts.format,
  });

  return {
    iso: date.toISOString(),
    format: typeof value === 'string' && isMatch(value, opts.format) ? value : format(date, opts.format),
  };
};

// export const parseLocalDateToZoneDate = (value: unknown, opts: { zone: string; format: string }): string | null => {
//   if (typeof value === 'string') {
//     const localDate = parseDateZoneToLocalDate(value, { zone: opts.zone, format: opts.format });
//     if (isValid(localDate)) return parseLocalDateToISOZone(localDate, opts.zone);
//   }
//
//   if (value instanceof Date) {
//     return parseLocalDateToISOZone(value, opts.zone);
//   }
//
//   return null;
// };

export const clonedIsoString: (value: unknown, mode?: 'local' | 'utc') => unknown = (
  value: unknown,
  mode: 'local' | 'utc' = 'local'
) => {
  if (!value) return value;

  if (value instanceof Date) return value.toISOString();

  if (typeof value === 'string') {
    if (mode === 'utc') {
      // 2025-06-30 -> 2025-06-30T00:00:00.000Z
      const date = new Date(value);
      if (isValid(date) && !isNaN(date.getTime())) return date.toISOString();
    }

    // 2025-06-30 -> 2025-06-29T17:00:00.000Z
    const dateParts = value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    const date = dateParts
      ? new Date(parseInt(dateParts[1]), parseInt(dateParts[2]) - 1, parseInt(dateParts[3]))
      : new Date(value);

    if (isValid(date) && !isNaN(date.getTime())) return date.toISOString();
  }

  return value;
};
